import React from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from "react-router-dom";

function SliderSection() {
  const images = [
    // "/assets/sliders/snitch-store021.jpg",
    // "/assets/sliders/snitch-store022.jpg",
    // "/assets/sliders/snitch-store023.jpg",
    "/assets/sliders/1.png",
    "/assets/sliders/2.png",
    "/assets/sliders/3.png",
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 1000,
  };

  return (
    <section id="slider" className="m-0 p-0 md:h-[500px] cursor-pointer overflow-hidden">
        <Slider {...settings}>
      {images.map((image, index) => (
        <Link key={index} to={{ pathname: '/products'}}>
        <div key={index}>
          <img src={image} alt={`Slide ${index}`} />
        </div>
       </Link>
      ))}
    </Slider>
    </section>
  );
}

export default SliderSection;
